import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CustomQualification } from 'src/app/models/custom-qualification';
import { MasterQualification } from 'src/app/models/master-qualification';
import { RequestTypeQualification } from 'src/app/models/requesttypequalification';
import { ServiceDef } from 'src/app/models/service-def';
import { ServiceQualification } from 'src/app/models/service-qualification';
import { QualificationService } from 'src/app/services/qualifications.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import {CDK_DRAG_CONFIG, CdkDragDrop, CdkDragStart, moveItemInArray} from '@angular/cdk/drag-drop';
import { CdkColumnDef } from '@angular/cdk/table';
import { ElementRef } from '@angular/core';
import {DataRecord} from "../../../../requests/commands/req-status/req-status.component";

const DragConfig = {
	dragStartThreshold: 0,
	pointerDirectionChangeThreshold: 5,
	zIndex: 10000
};

@Component({
	selector: 'app-servicedef-qualifications-mapping',
	templateUrl: './servicedef-qualifications-mapping.component.html',
	styleUrls: ['./servicedef-qualifications-mapping.component.css'],
	providers: [CdkColumnDef, {provide: CDK_DRAG_CONFIG, useValue: DragConfig}],
})
export class ServicedefQualificationsMappingComponent {

	_selectedServiceDef: ServiceDef;
	strErr = '';

	availableQualifications: any;
	assignedQualifications: any;

	CustomQualificationsAll: CustomQualification[];
	masterQualificationsAll: MasterQualification[];
	masterQualificationsMappingList: RequestTypeQualification[];
	serviceQualificationsMappingList: ServiceQualification[];

	public dataSource1: MatTableDataSource<any>;
	public dataSource2: MatTableDataSource<any>;
	@ViewChild('tb2') table: MatTable<any>;

	Idx1 = -1;
	Idx2 = -1
	previousIndex = -1;
	currentIndex = -1;

	selectedRow1: any;
	selectedRow2: any;

	displayedColumns1 = ['question'];
	displayedColumns2 = ['sequence', 'qualifyType', 'question', 'required', 'qualifiedAutomatchValue'];

	strDescription1 = '';
	strDescription2 = '';
	isEditing = true;
	isEditable = false;

	public qualAutmatchValueList: any;

	dragBoundary: ElementRef;

	@Input() set selectedServiceDef(value: ServiceDef) {
		this._selectedServiceDef = value;
		this.onShowHandler(value);
	}

	@Output() closeEvent = new EventEmitter<any>();


	constructor(public serviceRequestsService: ServiceRequestsService, private qualificationService: QualificationService,
		private elementRef: ElementRef) {
		this.qualAutmatchValueList = [];
		this.qualAutmatchValueList.push({id:'All',description:'Accept All'});
		this.qualAutmatchValueList.push({id:'Yes',description:'Yes Only'});
		this.qualAutmatchValueList.push({id:'No',description:'No Only'});
	}

	public ngOnInit() {
		if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEF_QUALIFICATIONS', "WRITE")) {
			this.isEditable = true;
		}
	}
	ngAfterViewInit() {
		this.dragBoundary = this.elementRef.nativeElement.querySelector('.table-container');
	}

	public onShowHandler(record: ServiceDef) {

		this.queryRecords();
	}

	queryRecords() {
		this.qualificationService.getAllMasterQualifications().subscribe(
			(result1) => {
				this.masterQualificationsAll = result1.filter(s => s.activeStatus === 'Active');
				this.qualificationService.getAllCustomQualificationsByAgencyId(Settings.getInstance().loggedInUser.agencyId).subscribe(
					(result2) => {
						this.CustomQualificationsAll = result2.filter(s => s.activeStatus === 'Active');
						//this.dataSourceAvaialble = new MatTableDataSource(this.availableCustomQualifications);
						this.qualificationService.getAllRequestTypeQualificationsByRequestTypeId(this._selectedServiceDef.serviceRequestTypeId).subscribe(
							(result3) => {
								this.masterQualificationsMappingList = result3;
								this.qualificationService.getAllServiceQualificationsByServiceDefId(this._selectedServiceDef.id).subscribe(
									(result4) => {
										this.serviceQualificationsMappingList = result4;
										//this.assignedQualifications = new MatTableDataSource(this.assignedMasterQualifications);
										this.prepareListsAndDisplay();
									},
									(error4) => {
										Settings.getInstance().handleError(error4, 'Error: unable to retrieve custom qualifications data from the service');
									}
								);

							},
							(error3) => {
								Settings.getInstance().handleError(error3, 'Error: unable to retrieve custom qualifications data from the service');
							}
						);
					},
					(error2) => {
						Settings.getInstance().handleError(error2, 'Error: unable to retrieve custom qualifications data from the service');
					}
				);
			},
			(error1) => {
				Settings.getInstance().handleError(error1, 'Error: unable to retrieve custom qualifications data from the service');

			}
		);
	}

	prepareListsAndDisplay() {
		this.assignedQualifications = [];
		this.availableQualifications = [];

		for (const rec of this.masterQualificationsMappingList) {
			let assigned = rec;
			const masterQualifyRecord = this.getMasterQualificationRecordById(assigned.masterQualificationId);

			/** Note if there are inactive records - skip them ***/
			if(masterQualifyRecord.id === 0) {
				continue;
			}

			for (const mapping of this.serviceQualificationsMappingList) {
				if (rec.masterQualificationId === mapping.masterQualificationId) {
					assigned['sequence'] = mapping.sequence;
					assigned['qualifiedAutomatchValue'] = mapping.qualifiedAutomatchValue;
				}
			}
			assigned['masterFlag'] = true;
			assigned['question'] = masterQualifyRecord.question;
			assigned['description'] = masterQualifyRecord.description;

			if(assigned['qualifiedAutomatchValue'] === undefined) {
				assigned['qualifiedAutomatchValue'] = 'All';
			}

			this.assignedQualifications.push(assigned);
		}
		//Now we need to load custom qualifications mapping and populate both the grids accordingly

		for (const rec of this.CustomQualificationsAll) {
			let assigned = rec;
			for (const mapping of this.serviceQualificationsMappingList) {
				if (rec.id === mapping.customQualificationId) {
					assigned['sequence'] = mapping.sequence;
					assigned['required'] = mapping.required;
					assigned['masterFlag'] = false;
					assigned['customQualificationId'] = mapping.customQualificationId;
					assigned['qualifiedAutomatchValue'] = null; // not used for custom qualifications
					this.assignedQualifications.push(assigned);
				}
			}
		}

		for (const rec of this.CustomQualificationsAll) {
			let available = rec;
			if (!this.isCustomQualificationExistsInAssignedList(rec.id)) {
				available['masterFlag'] = false;
				available['customQualificationId'] = available.id;
				this.availableQualifications.push(available);
			}
		}
		this.appendSequentialSequenceValues();
		this.assignedQualifications.sort((a, b) => a.sequence - b.sequence);
		this.dataSource1 = new MatTableDataSource(this.availableQualifications);
		this.dataSource2 = new MatTableDataSource(this.assignedQualifications);
	}

	appendSequentialSequenceValues() {
		const maxSequence = Math.max(...this.assignedQualifications.map(item => item.sequence || 0));
		let sequence = maxSequence + 1;
		this.assignedQualifications.forEach(item => {
			if (!item.sequence) {
				item.sequence = sequence++;
			}
		});
	}

	onRowClicked1(selected) {
		this.selectedRow1 = selected;
		this.selectRow1();
	}
	onRowClicked2(selected) {
		this.selectedRow2 = selected;
		this.selectRow2();
	}

	public selectRow1() {
		if (this.selectedRow1.id === 0) {
			this.unSelectRow1();
			return;
		}
		this.strDescription1 = this.selectedRow1['description'];
		this.Idx1 = this.dataSource1.filteredData.findIndex(s => s.id === this.selectedRow1.id);

	}
	public unSelectRow1() {
		this.Idx1 = -1;
		this.selectedRow1 = undefined;
		this.strDescription1 = '';
	}

	public selectRow2() {
		if (this.selectedRow2.id === 0) {
			this.unSelectRow2();
			return;
		}
		this.strDescription2 = this.selectedRow2['description'];
		this.Idx2 = this.dataSource2.filteredData.findIndex(s => s.id === this.selectedRow2.id);

	}
	public unSelectRow2() {
		this.Idx2 = -1;
		this.selectedRow2 = undefined;
		this.strDescription2 = '';
	}

	getMasterQualificationRecordById(id: number) {
		for (const rec of this.masterQualificationsAll) {
			if (rec.id === id) { return rec; }
		}
		return new MasterQualification();
	}
	isCustomQualificationExistsInAssignedList(id: number) {
		for (const rec of this.assignedQualifications) {
			if (rec['customQualificationId'] === id) { return true; }
		}
		return false;
	}

	moveRight() {
		if (!this.selectedRow1 || this.Idx1 < 0 || !this.isEditable) {
			return;
		}
		this.selectedRow1['sequence'] = this.assignedQualifications.length + 1;
		this.assignedQualifications.push(this.selectedRow1);
		this.availableQualifications = this.availableQualifications.filter(item => item.id !== this.selectedRow1.id);
		this.unSelectRow1();
		this.dataSource1 = new MatTableDataSource(this.availableQualifications);
		this.dataSource2 = new MatTableDataSource(this.assignedQualifications);
	}
	moveLeft() {
		if (!this.selectedRow2 || this.Idx2 < 0 || this.selectedRow2['masterFlag'] === true || !this.isEditable) {
			return;
		}
		this.selectedRow2['sequence'] = this.assignedQualifications.length + 1;
		this.availableQualifications.push(this.selectedRow2);
		this.assignedQualifications = this.assignedQualifications.filter(item => item.customQualificationId !== this.selectedRow2.customQualificationId);
		this.unSelectRow2();
		this.updateSerialNumbers();
		this.dataSource1 = new MatTableDataSource(this.availableQualifications);
		this.dataSource2 = new MatTableDataSource(this.assignedQualifications);
	}

	submitRecord() {
		this.qualificationService.deleteAllServiceQualificationsByServiceDefId(this._selectedServiceDef.id).subscribe(
			() => {
				const promises = [];
				for (const rec of this.assignedQualifications) {
					const newRec: ServiceQualification = {
						id: 0,
						required: rec['required'] ? 1 : 0,
						sequence: rec['sequence'],
						serviceDefId: this._selectedServiceDef.id,
						masterQualificationId: rec['masterFlag'] === true ? rec['masterQualificationId'] : undefined,
						customQualificationId: rec['masterFlag'] === true ? undefined : rec['customQualificationId'],
						qualifiedAutomatchValue: rec['masterFlag'] === true ? rec['qualifiedAutomatchValue'] : undefined
					};

					const promise = this.qualificationService.createServiceQualification(newRec).toPromise();
					promises.push(promise);
				}

				Promise.all(promises).then(
					(result) => {
						//Now all API save calls have been completed.
						this.closeEvent.emit();
					},
					(error) => {
						this.strErr = 'Error: The server could not add/submit some records';
					}
				);
			},
			(error) => {
				Settings.getInstance().handleError(error);
			}
		);
	}
	automatchValueSelected(event:any ): void {

	}
	cancelSubmitRecord() {
		this.strErr = '';
		this.strDescription1 = '';
		this.strDescription2 = '';
		this.queryRecords();
	}

	drop(event: CdkDragDrop<any[]>) {
		const prevIndex = this.assignedQualifications.findIndex((d) => d === event.item.data);
		moveItemInArray(this.assignedQualifications, prevIndex, event.currentIndex);
		this.dataSource2 = new MatTableDataSource(this.assignedQualifications);
		this.updateSerialNumbers();
		//this.table.renderRows();
	}
	getBackgroundColor(elem: boolean): string {
		if(elem === null) {
			return;
		}
		if(elem === true) {
			return 'purple';
		}
		return 'green';
	}
	getQuestionType(elem: boolean): string
	{
		if(elem === null) {
			return;
		}
		if(elem === true) {
			return 'Master';
		}
		return 'Custom';
	}
	updateSerialNumbers() {
		// Update serial numbers based on the new order of items in the assignedQualifications array
		for (let i = 0; i < this.assignedQualifications.length; i++) {
			this.assignedQualifications[i].sequence = i + 1;
		}
	}
}
